import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiStripepaymentgatewaySaveCardTransLogMutationRequest,
  PostApiStripepaymentgatewaySaveCardTransLogMutationResponse,
  PostApiStripepaymentgatewaySaveCardTransLog401,
  PostApiStripepaymentgatewaySaveCardTransLog403,
} from "../../../types/PostApiStripepaymentgatewaySaveCardTransLog";

export function getPostApiStripepaymentgatewaySaveCardTransLogUrl() {
  return `/api/StripePaymentGateway/save-card-trans-log` as const;
}

/**
 * {@link /api/StripePaymentGateway/save-card-trans-log}
 */
export async function postApiStripepaymentgatewaySaveCardTransLog(
  data?: PostApiStripepaymentgatewaySaveCardTransLogMutationRequest,
  config: Partial<
    RequestConfig<PostApiStripepaymentgatewaySaveCardTransLogMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiStripepaymentgatewaySaveCardTransLogMutationResponse,
    ResponseErrorConfig<
      | PostApiStripepaymentgatewaySaveCardTransLog401
      | PostApiStripepaymentgatewaySaveCardTransLog403
    >,
    PostApiStripepaymentgatewaySaveCardTransLogMutationRequest
  >({
    method: "POST",
    url: getPostApiStripepaymentgatewaySaveCardTransLogUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
